/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-change-temporary-password-dialog kendo-dialog.k-dialog-wrapper{background-color:rgba(0,0,0,.8)}"];
export { styles as styles };
